import requestCaptchaPasswordReset from 'src/dataLayer/remoteData/babbelAPI/requestCaptchaPasswordReset';
import useAsyncData from 'src/viewLayer/components/hooks/useAsyncData';

export default function useHandleCaptchaPasswordResetRequest() {

  const {
    data,
    makeRequest,
    inProgress
  } = useAsyncData(() => requestCaptchaPasswordReset());

  return {
    captchaConfig: data || null,
    makeCaptchaPasswordResetRequest: makeRequest,
    captchaPasswordResetRequestInProgress: inProgress
  };
};
